export default "__VITE_ASSET__D0bOtTHz__"